module.exports = __webpack_public_path__ + "media/images/ui/arrow-up-light-8e71ec6aebb0061fe1098526a55031e7.png";